module.exports = __webpack_public_path__ + "img/alexanders-tomb.fc37ad7a.jpg";